import React, { useState } from "react";
import styled from "styled-components";
import ProjectModal from "../../components/ProjectModal";

import lecoLogo from "../../assets/images/projets/lecozenLogo.png";
import lecoImg from "../../assets/images/projets/pc_lecozenWebMob.png";
import lecoImg1 from "../../assets/images/projets/leco-franceMob.png";
import lecoImg2 from "../../assets/images/projets/lecozenAdmin1.png";

import manoirImg from "../../assets/images/projets/lemanoiretoileWebSite.png";
import manoirLogo from "../../assets/images/logo_lemanoiretoile.png";

import amelieImg from "../../assets/images/projets/pc_amelieWeb.png";
import amelieLogo from "../../assets/images/projets/amelieLogo.jpeg";

import morganImg from "../../assets/images/projets/pc_morganCoiffureWebMob.png";
import morganLogo from "../../assets/images/projets/morganLogo.png";

import hexagoneImg from "../../assets/images/projets/pc_hexagoneWebMob.png";
import hexagoneLogo from "../../assets/images/projets/hexagoneLogo.jpg";
import hexagoneImg1 from "../../assets/images/projets/hexagoneAdmin1.png";
import hexagoneImg2 from "../../assets/images/projets/hexagoneAdmin2.png";
import hexagoneImg3 from "../../assets/images/projets/hexagoneAdmin3.png";

import semaphoresImg from "../../assets/images/projets/pc_semaphores.png";
import semaphoresLogo from "../../assets/images/projets/semaphoresLogo.png";

import nicolasImg from "../../assets/images/projets/pc_nicolasWeb.png";
import nicolasLogo from "../../assets/images/projets/nicolasLogo.png";

import { Inner } from "../../components/commonWidgets";
import HighlightTitle from "../../components/HighlightTitle";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import AnimateOnScroll from "../../components/AnimateOnScroll";

const Section = styled.div`
  /*background-color: var(--my-color1);*/
  width: 100% !important;
  position: relative;
`;

const PrjectsContainers = styled(Inner)`
  display: flex;
  max-width: 800px;
  flex-direction: column;
  margin: auto;
  margin-bottom: 2rem;
`;

const CarouselWrapper = styled.div`
  width: 100%;
  margin-top: 2rem;

  .swiper {
    padding-bottom: 2.5rem;
  }

  .swiper-pagination-bullet {
    background: var(--my-color3);
    opacity: 0.4;
  }

  .swiper-pagination-bullet-active {
    background: var(--my-color5);
    opacity: 1;
  }
`;

const ProjectItem = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  max-width: 20rem;
  position: relative;
  width: 100%;
  min-width: 12rem;
  flex-shrink: 0;
`;

const ProjectItemImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-height: 7rem;
    padding: 2rem;
    max-width: 100%;
  }
`;

const ProjectTitle = styled.img`
  text-align: center;
  font-weight: bold;
  color: var(--my-color3);
  text-transform: uppercase;
  display: block;
  background: white;
  border-radius: 10px;
  position: absolute;
  bottom: 0rem;
  max-height: 7rem;
  margin: 1rem;
  aspect-ratio: 1;
  object-fit: contain;
  opacity: 1;
  z-index: 0;
  max-width: 20rem;
  min-width: 12rem;
  width: 80%;
  border: 1rem white solid;

  &:hover {
    transition: opacity 0.3s ease;
    opacity: 0;
  }
`;

const ArrowLink = styled.a`
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
  width: 2rem;
  height: 2rem;
  z-index: 1;

  img {
    max-height: 7rem;
    width: auto;
  }
`;

const NavButton = styled.button`
  position: absolute;
  top: 40%;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 50%;
  padding: 0.5rem;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};

  img {
    width: 1.5rem;
    height: 1.5rem;
    transform: ${(props) =>
      props.direction === "left" ? "rotate(180deg)" : "none"};
  }

  ${(props) =>
    props.direction === "left"
      ? `
    left: 0.5rem;
  `
      : `
    right: 0.5rem;
  `}
`;

const ProjectsSection = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      title: "Lécozen",
      mainImage: lecoImg,
      logo: lecoLogo,
      link: "https://lecozen.fr",
      carousel: [lecoLogo, lecoImg, lecoImg1, lecoImg2],
      description:
        "Plateforme chauffeurs : +40 % d'engagement et -25 % de sinistralité dès la première année.",
      features: [
        {
          title: "Site vitrine responsive",
          text: "qui rassure assureurs et partenaires",
        },
        {
          title: "CRM intégré",
          text: "suivi utilisateurs, formations et relances automatiques",
        },
        {
          title: "Tableaux de bord formateurs",
          text: "scores, plans d'action et suivi sinistres",
        },
        {
          title: "Pilotage parc poids lourds",
          text: "données centralisées, reporting et alertes",
        },
      ],
      technologies: [
        "Plateforme SaaS",
        "CRM & Suivi",
        "Application mobile",
        "Tableaux de bord",
        "Reporting & Analytics",
        "Automatisation",
      ],
    },
    {
      title: "Amélie...",
      mainImage: amelieImg,
      logo: amelieLogo,
      link: "https://amelieparis15.fr",
      carousel: [amelieLogo, amelieImg],
      description:
        "Site vitrine lancé en 3 semaines : +55 % de RDV en ligne le premier trimestre.",
      features: [
        {
          title: "Design rock & élégant",
          text: "qui affirme l'identité du salon",
        },
        {
          title: "Réservation en ligne",
          text: "tunnel ultra-simple (moins de 30 s)",
        },
        { title: "Preuve sociale", text: "avis Google (4,9/5) mis en avant" },
        { title: "Mobile-first", text: "optimisé pour recherche locale" },
      ],
      technologies: [
        "Site vitrine",
        "Réservation en ligne",
        "Intégration avis Google",
        "SEO local",
        "Design sur-mesure",
        "Mobile-first",
        "Preuve sociale",
      ],
    },
    {
      title: "Hexagone",
      mainImage: hexagoneImg,
      logo: hexagoneLogo,
      link: "",
      carousel: [
        hexagoneLogo,
        hexagoneImg,
        hexagoneImg1,
        hexagoneImg2,
        hexagoneImg3,
      ],
      description:
        "Portail adhérents : 1 500 membres actifs, +70 % de taux de connexion mensuel.",
      features: [
        {
          title: "Espace adhérents sécurisé",
          text: "cotisations, documents et événements centralisés",
        },
        {
          title: "App mobile push",
          text: "notifications pour engagement quotidien",
        },
        {
          title: "Pilotage simplifié",
          text: "moins de tâches manuelles, plus d'animation réseau",
        },
        {
          title: "Image modernisée",
          text: "portail professionnel renforçant la crédibilité",
        },
      ],
      technologies: [
        "Portail adhérents",
        "Espace membre sécurisé",
        "Application mobile",
        "Notifications push",
        "Gestion de contenu",
        "Paiement en ligne",
        "Administration simplifiée",
      ],
    },
    {
      title: "Sémaphores",
      mainImage: semaphoresImg,
      logo: semaphoresLogo,
      link: "https://semaphores.eu",
      carousel: [semaphoresLogo, semaphoresImg],
      description:
        "Nouveau site multilingue conçu pour valoriser l'expertise de Sémaphores et sécuriser sa présence en ligne.",
      features: [
        {
          title: "Refonte complète",
          text: "conservation du nom de domaine et capital confiance",
        },
        {
          title: "Architecture claire",
          text: "Accueil, Expertises (interprétation, traduction, rédaction, sous-titrage), Contact",
        },
        {
          title: "Navigation rassurante",
          text: "parcours optimisé pour conversion et demande de devis",
        },
        {
          title: "Multilingue",
          text: "structure fluide UX et SEO international",
        },
      ],
      technologies: [
        "Refonte site",
        "Site multilingue",
        "SEO international",
        "Architecture UX",
        "Performance",
        "Design professionnel",
        "Stratégie digitale",
      ],
    },
    {
      title: "Nicolas Krastev McKinnon",
      mainImage: nicolasImg,
      logo: nicolasLogo,
      link: "https://nicolaskrastevmckinnon.net",
      carousel: [nicolasLogo, nicolasImg],
      description:
        "Site vitrine pour écrivain et rédacteur stratégique : plume pour dirigeants, rédaction stratégique, séminaires d'écriture.",
      features: [
        {
          title: "Design littéraire et épuré",
          text: "identité forte, slogan percutant (« Les mots flous rassurent. Les mots justes engagent. »)",
        },
        {
          title: "Présentation des services",
          text: "rédaction stratégique, plume de dirigeant-e, séminaires & ateliers d'écriture",
        },
        {
          title: "Crédibilité renforcée",
          text: "livres publiés, références éditoriales (JC Lattès, Philippe Rey), formulaire de contact",
        },
        {
          title: "Vitrine professionnelle",
          text: "navigation claire, CTA vers proposition de projet",
        },
      ],
      technologies: [
        "Site vitrine",
        "Design sur-mesure",
        "SEO",
        "Architecture éditoriale",
        "Formulaires de contact",
        "Performance",
        "Identité de marque",
      ],
    },
    {
      title: "Morgan Salon",
      mainImage: morganImg,
      logo: morganLogo,
      // link: '',
      carousel: [morganLogo, morganImg],
      description:
        "Site vitrine + calendrier : agenda rempli à 90 % chaque semaine.",
      features: [
        {
          title: "Galerie avant/après",
          text: "pour rassurer les nouveaux clients",
        },
        {
          title: "Réservation en ligne",
          text: "connectée au planning, réduit les appels",
        },
        { title: "Mobile-first", text: "optimisé pour réservation smartphone" },
        { title: "Vitrine rassurante", text: "renforce la visibilité locale" },
      ],
      technologies: [
        "Site vitrine",
        "Réservation en ligne",
        "Galerie photo",
        "SEO local",
        "Design sur-mesure",
        "Mobile-first",
        "Gestion planning",
      ],
    } /*
    {
      title: "Le Manoir Étoilé",
      mainImage: manoirImg,
      logo: manoirLogo,
      link: "https://lemanoiretoile.fr",
      carousel: [manoirLogo, manoirImg],
      description: "Refonte UX : +30 % de paniers cadeaux vendus en ligne.",
      features: [
        "Catalogue prestations clair et filtrable",
        "Formulaire de contact simplifié (conversion x2)",
        "Design premium qui reflète le standing du spa",
      ],
    },*/,
  ];

  return (
    <Section>
      <PrjectsContainers>
        <HighlightTitle
          text="Projets récents"
          bg="var(--my-color3)"
          mainTextColor="var(--my-color3)"
          textColor="white"
        />
        <CarouselWrapper>
          <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {projects.map((proj, index) => (
              <SwiperSlide key={index}>
                <AnimateOnScroll type="fade">
                  <ProjectItem onClick={() => setSelectedProject(proj)}>
                    <ProjectItemImg>
                      <img src={proj.mainImage} alt={proj.title} />
                    </ProjectItemImg>
                    <ProjectTitle src={proj.logo} alt={`Logo-${proj.title}`} />
                  </ProjectItem>
                </AnimateOnScroll>
              </SwiperSlide>
            ))}
          </Swiper>
        </CarouselWrapper>
      </PrjectsContainers>

      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </Section>
  );
};

export default ProjectsSection;
